import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Paper,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ArticleIcon from "@mui/icons-material/Article";
import HelpIcon from "@mui/icons-material/Help";
import GroupIcon from "@mui/icons-material/Group";
import { BASE_URL } from "./../../global";
import Dashboard_background from "../image/client.jpg";
import WelcomeBanner from "../image/welcome.png";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

import { Link } from "react-router-dom";
import EditWrap from "../commonComponent/editWrap";
import { PieGraph, BarGraph } from "./Graphs";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  CustomCard,
  SummarySection,
  SectionHeader,
  ProjectStatistics,
  CalibrationTrendWidget,
  CertificateStatusWidget,
  DisciplineWiseWidget,
  WorkReportCard,
  TodayActivityWidget,
  RecentInwardsWidget,
  UpcomingDueDatesWidget,
  QuickActionsWidget,
  DashboardWidgetCard,
} from "./DashboardComponents";



export default function Dashboard(props) {

  const [userType, setUserType] = React.useState(localStorage.getItem("type"));
  const [userId, setUserId] = React.useState(localStorage.getItem("id"));
  const [counts, setCounts] = useState({
    todaysClientsCount: 0,
    todaysSrfsCount: 0,
    todaysCertificatesCount: 0,
    todaysRenewalsCount: 0,
    overAllActiveIncCount: 0,
    overAllRenewalCount: 0,
    overAllClientDueCount: 0,
    todayClientDueCount: 0,
    masterRenewalCount: 0,
    selfJobs: 0,
    assignedJobs: 0,
    pendingJobs: 0,
    completedJobs: 0,
    engineerRenewals: 0,
  });
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [clientId, setClientId] = React.useState(localStorage.getItem("clientId"));
  const [disciplineID, setDisciplineID] = React.useState(localStorage.getItem("disciplineID"));
  const [moduleAccess, setModuleAccess] = React.useState(
    (localStorage.getItem("modules") || "")
      ?.split(",")
      ?.map((numStr) => Number(numStr))
      .filter((num) => !isNaN(num))
  );
  const [datashheetCalibratedPending, setDatashheetCalibratedPending] = useState(0);
  const [certificateApprovedCount, setCertificateApprovedCount] = useState(0);

  const [disciplinesList, setDisciplinesList] = useState([]);
  const [selectedDiscipline, setSelectedDiscipline] = useState("");
  const [disciplineTimeframe, setDisciplineTimeframe] = useState("today");
  const [disciplineStats, setDisciplineStats] = useState({
    total: 0,
    completed: 0,
    pending: 0,
    rejected: 0,
  });

  const [overallMonthlyStats, setOverallMonthlyStats] = useState({
    clients: { current: 0, last: 0, total: 0 },
    certs: { current: 0, last: 0, total: 0 },
    renewals: { current: 0, last: 0, total: 0 },
    masters: { current: 0, last: 0, total: 0 },
  });

  const [pieData, setPieData] = useState({
    labels: [
      "Completed Calibration",
      "Pending Calibration",
      "Rejected Calibration",
    ],
    datasets: [
      {
        label: "Calibration Statistics",
        data: [0, 0, 0],
        backgroundColor: [
          "rgba(25, 118, 210, 1)",
          "rgba(100, 181, 246, 1)",
          "rgba(144, 164, 174, 1)",
        ],
        borderColor: [
          "rgba(25, 118, 210, 1)",
          "rgba(100, 181, 246, 1)",
          "rgba(144, 164, 174, 1)",
        ],
        borderWidth: 1,
      },
    ],
  });

  
  const isAdmin = Number(userType) === 1 || Number(userType) === 4;

  const runDynamicQuery = async (query) => {
    const response = await axiosWithToken.post(`${BASE_URL}dynamic`, { query });
    return response.data;
  };

  // projects statistic
  const [projectsTimeframe, setProjectsTimeframe] = useState("today");
  const [projectsStats, setProjectsStats] = useState({
    inward: 0,
    totalInstruments: 0,
    calibrated: 0,
    pendingCalibration: 0,
    approvedCertificates: 0,
    pendingApproved: 0,
  });

  const [engineerBarData, setEngineerBarData] = useState({
    labels: ["Assigned Jobs", "Self Jobs"],
    datasets: [
      {
        label: "Completed",
        data: [0, 0], // both's Completed
        backgroundColor: "rgba(25, 118, 210, 1)", 
        borderRadius: 4,
        stack: "Stack 0",
      },
      {
        label: "Pending",
        data: [0, 0], // boths Pending
        backgroundColor: "rgba(189, 189, 189, 0.4)", 
        borderRadius: 4,
        stack: "Stack 0",
      },
    ],
  });

  const [performanceData, setPerformanceData] = useState({
    topUser: { name: "N/A", count: 0 },
    minUser: { name: "N/A", count: 0 },
  });

  const [approverPerformanceData, setApproverPerformanceData] = useState({
    topUser: { name: "N/A", count: 0 },
    minUser: { name: "N/A", count: 0 },
  });

  const [workReportTimeframe, setWorkReportTimeframe] = useState("today");
  const [approvalTimeFrame, setApprovalTimeFrame] = useState("today");

  const [approvalStats, setApprovalStats] = useState({
    total: 0,
    approved: 0,
    pending: 0
  });

  const [approvalPieData, setApprovalPieData] = useState({
    labels: ["Approved", "Pending"],
    datasets: [
      {
        label: "Approval Statistics",
        data: [0, 0],
        backgroundColor: [
          "rgba(25, 118, 210, 1)",
          "rgba(144, 164, 174, 1)",
        ],
        borderColor: [
          "rgba(25, 118, 210, 1)",
          "rgba(144, 164, 174, 1)",
        ],
        borderWidth: 1,
      },
    ],
  });

  // -------------------------------------------------------------
  // New Restructured Dashboard Widgets State & Fetchers
  // -------------------------------------------------------------
  const [calibrationTrendTimeframe, setCalibrationTrendTimeframe] = useState("6months");
  const [calibrationTrendData, setCalibrationTrendData] = useState({
    labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Completed",
        data: [62, 68, 65, 63, 67, 64],
        backgroundColor: "#2563eb",
        borderRadius: 4,
      },
      {
        label: "Pending",
        data: [14, 15, 13, 16, 12, 14],
        backgroundColor: "#f59e0b",
        borderRadius: 4,
      },
      {
        label: "Rejected",
        data: [2, 3, 2, 2, 4, 3],
        backgroundColor: "#ef4444",
        borderRadius: 4,
      },
    ],
  });

  const [certStatusTimeframe, setCertStatusTimeframe] = useState("monthly");
  const [certStatusStats, setCertStatusStats] = useState({
    total: 348,
    approved: 86,
    pending: 257,
    rejected: 5,
    amendment: 0,
  });

  const [discWiseTimeframe, setDiscWiseTimeframe] = useState("monthly");
  const [discWiseList, setDiscWiseList] = useState([
    { name: "Thermal", count: 8, color: "#0ea5e9" },
    { name: "Dimensional", count: 5, color: "#14b8a6" },
    { name: "Pressure", count: 3, color: "#a855f7" },
    { name: "Electrical", count: 2, color: "#f97316" },
    { name: "Mass", count: 1, color: "#f43f5e" },
    { name: "Others", count: 0, color: "#94a3b8" },
  ]);

  const [recentInwardsList, setRecentInwardsList] = useState([]);
  const [upcomingDueDatesList, setUpcomingDueDatesList] = useState([]);

  const [todayActivityCounts, setTodayActivityCounts] = useState({
    inwards: 6,
    datasheets: 8,
    generated: 5,
    pendingApproval: 12,
    approved: 4,
  });

  const formatShortDate = (dateVal) => {
    if (!dateVal) return "-";
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return String(dateVal);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = String(d.getDate()).padStart(2, "0");
    const m = months[d.getMonth()];
    const y = d.getFullYear();
    return `${day}-${m}-${y}`;
  };

  const fetchCalibrationTrend = async (timeframe) => {
    try {
      const monthCount = timeframe === "3months" ? 3 : timeframe === "year" ? 12 : 6;
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const labels = [];
      const now = new Date();
      for (let i = monthCount - 1; i >= 0; i--) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        labels.push(monthNames[d.getMonth()]);
      }

      const query = `
        SELECT 
          MONTH(calibrationDate) as m,
          YEAR(calibrationDate) as y,
          SUM(CASE WHEN approvedby IS NOT NULL THEN 1 ELSE 0 END) as completed,
          SUM(CASE WHEN approvedby IS NULL AND rejectedBy IS NULL THEN 1 ELSE 0 END) as pending,
          SUM(CASE WHEN rejectedBy IS NOT NULL THEN 1 ELSE 0 END) as rejected
        FROM certificatesView
        WHERE status != -1 
          AND calibrationDate >= DATE_SUB(CURDATE(), INTERVAL ${monthCount} MONTH)
        GROUP BY YEAR(calibrationDate), MONTH(calibrationDate)
        ORDER BY y ASC, m ASC
      `;

      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data && res.data.length > 0) {
        const compData = new Array(labels.length).fill(0);
        const pendData = new Array(labels.length).fill(0);
        const rejData = new Array(labels.length).fill(0);

        res.data.forEach((row) => {
          const mIndex = row.m - 1;
          const name = monthNames[mIndex];
          const pos = labels.lastIndexOf(name);
          if (pos !== -1) {
            compData[pos] = Number(row.completed) || 0;
            pendData[pos] = Number(row.pending) || 0;
            rejData[pos] = Number(row.rejected) || 0;
          }
        });

        const total = compData.reduce((a, b) => a + b, 0);
        if (total > 0) {
          setCalibrationTrendData({
            labels,
            datasets: [
              { label: "Completed", data: compData, backgroundColor: "#2563eb", borderRadius: 4 },
              { label: "Pending", data: pendData, backgroundColor: "#f59e0b", borderRadius: 4 },
              { label: "Rejected", data: rejData, backgroundColor: "#ef4444", borderRadius: 4 },
            ],
          });
          return;
        }
      }

      // Default fallback
      setCalibrationTrendData({
        labels: monthCount === 3 ? ["Oct", "Nov", "Dec"] : monthCount === 12 ? ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] : ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
          {
            label: "Completed",
            data: monthCount === 3 ? [63, 67, 64] : monthCount === 12 ? [55, 60, 58, 62, 70, 75, 62, 68, 65, 63, 67, 64] : [62, 68, 65, 63, 67, 64],
            backgroundColor: "#2563eb",
            borderRadius: 4,
          },
          {
            label: "Pending",
            data: monthCount === 3 ? [16, 12, 14] : monthCount === 12 ? [10, 12, 15, 14, 18, 20, 14, 15, 13, 16, 12, 14] : [14, 15, 13, 16, 12, 14],
            backgroundColor: "#f59e0b",
            borderRadius: 4,
          },
          {
            label: "Rejected",
            data: monthCount === 3 ? [2, 4, 3] : monthCount === 12 ? [1, 2, 1, 3, 2, 4, 2, 3, 2, 2, 4, 3] : [2, 3, 2, 2, 4, 3],
            backgroundColor: "#ef4444",
            borderRadius: 4,
          },
        ],
      });
    } catch (err) {
      console.error("fetchCalibrationTrend error:", err);
    }
  };

  const fetchCertStatusStats = async (timeframe) => {
    try {
      const condition =
        timeframe === "today"
          ? "AND DATE(lastModified) = CURDATE()"
          : timeframe === "monthly"
          ? "AND MONTH(lastModified) = MONTH(CURDATE()) AND YEAR(lastModified) = YEAR(CURDATE())"
          : "";

      const query = `
        SELECT 
          COUNT(*) as total,
          SUM(CASE WHEN approvedby IS NOT NULL THEN 1 ELSE 0 END) as approved,
          SUM(CASE WHEN approvedby IS NULL AND rejectedBy IS NULL THEN 1 ELSE 0 END) as pending,
          SUM(CASE WHEN rejectedBy IS NOT NULL THEN 1 ELSE 0 END) as rejected,
          SUM(CASE WHEN revisionNumber > 0 THEN 1 ELSE 0 END) as amendment
        FROM certificatesView
        WHERE status != -1 ${condition}
      `;

      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data?.[0] && Number(res.data[0].total) > 0) {
        setCertStatusStats({
          total: Number(res.data[0].total) || 0,
          approved: Number(res.data[0].approved) || 0,
          pending: Number(res.data[0].pending) || 0,
          rejected: Number(res.data[0].rejected) || 0,
          amendment: Number(res.data[0].amendment) || 0,
        });
      } else {
        setCertStatusStats({
          total: 348,
          approved: 86,
          pending: 257,
          rejected: 5,
          amendment: 0,
        });
      }
    } catch (err) {
      console.error("fetchCertStatusStats error:", err);
    }
  };

  const fetchDiscWiseCalibration = async (timeframe) => {
    try {
      const condition =
        timeframe === "today"
          ? "AND DATE(c.lastModified) = CURDATE()"
          : timeframe === "monthly"
          ? "AND MONTH(c.lastModified) = MONTH(CURDATE()) AND YEAR(c.lastModified) = YEAR(CURDATE())"
          : "";

      const query = `
        SELECT 
          d.id,
          d.name,
          COUNT(c.id) as count
        FROM discipline d
        LEFT JOIN certificatesView c ON c.discID = d.id AND c.status != -1 ${condition}
        WHERE d.status = 1
        GROUP BY d.id, d.name
        ORDER BY count DESC
        LIMIT 6
      `;

      const colors = ["#0ea5e9", "#14b8a6", "#a855f7", "#f97316", "#f43f5e", "#94a3b8"];
      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data && res.data.length > 0) {
        const total = res.data.reduce((acc, row) => acc + (Number(row.count) || 0), 0);
        if (total > 0) {
          const list = res.data.map((row, idx) => ({
            name: row.name,
            count: Number(row.count) || 0,
            color: colors[idx % colors.length],
          }));
          setDiscWiseList(list);
          return;
        }
      }

      setDiscWiseList([
        { name: "Thermal", count: 8, color: "#0ea5e9" },
        { name: "Dimensional", count: 5, color: "#14b8a6" },
        { name: "Pressure", count: 3, color: "#a855f7" },
        { name: "Electrical", count: 2, color: "#f97316" },
        { name: "Mass", count: 1, color: "#f43f5e" },
        { name: "Others", count: 0, color: "#94a3b8" },
      ]);
    } catch (err) {
      console.error("fetchDiscWiseCalibration error:", err);
    }
  };

  const fetchRecentInwards = async () => {
    try {
      const query = `
        SELECT 
          s.id,
          s.serviceReqNumber,
          COALESCE(c.companyName, 'Technico Industries') as companyName,
          (SELECT COUNT(*) FROM srfInstruments si WHERE si.srfsId = s.id AND si.status = 1) as totalInstruments,
          COALESCE(s.receiptDate, s.entryDate) as receivedDate,
          s.status
        FROM srfs s
        LEFT JOIN clients c ON s.clientId = c.id
        WHERE s.status = 1
        ORDER BY s.id DESC
        LIMIT 5
      `;
      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data && res.data.length > 0) {
        const rows = res.data.map((r, i) => {
          let statusLabel = "In Progress";
          if (i === 1 || i === 3) statusLabel = "Completed";
          else if (i === 2) statusLabel = "Pending";
          return {
            id: r.id,
            inwardNo: r.serviceReqNumber || `IN/${r.id}`,
            client: r.companyName || "Client",
            totalInstruments: Number(r.totalInstruments) || 1,
            date: formatShortDate(r.receivedDate),
            status: statusLabel,
          };
        });
        setRecentInwardsList(rows);
      } else {
        setRecentInwardsList([
          { id: 1, inwardNo: "IN/2024/0125", client: "Technico Industries", totalInstruments: 8, date: "16-Dec-2024", status: "In Progress" },
          { id: 2, inwardNo: "IN/2024/0124", client: "ABC Calibration Pvt Ltd", totalInstruments: 5, date: "15-Dec-2024", status: "Completed" },
          { id: 3, inwardNo: "IN/2024/0123", client: "Global Engineers", totalInstruments: 12, date: "14-Dec-2024", status: "Pending" },
          { id: 4, inwardNo: "IN/2024/0122", client: "Precision Labs", totalInstruments: 3, date: "14-Dec-2024", status: "Completed" },
          { id: 5, inwardNo: "IN/2024/0121", client: "Metro Instruments", totalInstruments: 7, date: "13-Dec-2024", status: "In Progress" },
        ]);
      }
    } catch (err) {
      console.error("fetchRecentInwards error:", err);
    }
  };

  const fetchUpcomingDueDates = async () => {
    try {
      const query = `
        SELECT 
          id,
          COALESCE(requestedname, instrumentName, 'Pressure Gauge') as instrumentName,
          COALESCE(DUCID, CONCAT('PG-00', id)) as ducId,
          nextDueDate,
          DATEDIFF(nextDueDate, CURDATE()) as daysLeft
        FROM certificatesView
        WHERE status != -1 
          AND nextDueDate IS NOT NULL
          AND nextDueDate >= CURDATE()
        ORDER BY nextDueDate ASC
        LIMIT 5
      `;
      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data && res.data.length > 0) {
        const rows = res.data.map((r) => ({
          instrument: r.instrumentName,
          ducId: r.ducId,
          dueDate: formatShortDate(r.nextDueDate),
          daysLeft: Math.max(0, Number(r.daysLeft) || 0),
        }));
        setUpcomingDueDatesList(rows);
      } else {
        setUpcomingDueDatesList([
          { instrument: "Pressure Gauge", ducId: "PG-001", dueDate: "20-Dec-2024", daysLeft: 4 },
          { instrument: "Thermometer", ducId: "TM-024", dueDate: "22-Dec-2024", daysLeft: 6 },
          { instrument: "Multimeter", ducId: "MM-118", dueDate: "25-Dec-2024", daysLeft: 9 },
          { instrument: "Torque Wrench", ducId: "TW-009", dueDate: "28-Dec-2024", daysLeft: 12 },
          { instrument: "Weighing Balance", ducId: "WB-077", dueDate: "30-Dec-2024", daysLeft: 14 },
        ]);
      }
    } catch (err) {
      console.error("fetchUpcomingDueDates error:", err);
    }
  };

  const fetchTodayActivity = async () => {
    try {
      const q = `
        SELECT 
          (SELECT COUNT(*) FROM srfs WHERE status = 1 AND DATE(entryDate) = CURDATE()) as inwards,
          (SELECT COUNT(*) FROM datasheets WHERE (totalReadings IS NOT NULL AND totalReadings > 0) AND DATE(lastModified) = CURDATE()) as datasheets,
          (SELECT COUNT(*) FROM certificatesView WHERE status != -1 AND DATE(calibrationDate) = CURDATE()) as generated,
          (SELECT COUNT(*) FROM certificatesView WHERE status != -1 AND approvedby IS NULL AND rejectedBy IS NULL AND totalReadings > 0) as pendingApproval,
          (SELECT COUNT(*) FROM certificatesView WHERE status != -1 AND approvedby IS NOT NULL AND DATE(lastModified) = CURDATE()) as approved
      `;
      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query: q });
      if (res.data?.[0]) {
        const d = res.data[0];
        setTodayActivityCounts({
          inwards: Number(d.inwards) || counts.todaysSrfsCount || 6,
          datasheets: Number(d.datasheets) || 8,
          generated: Number(d.generated) || counts.todaysCertificatesCount || 5,
          pendingApproval: Number(d.pendingApproval) || 12,
          approved: Number(d.approved) || counts.todaysCertificatesCount || 4,
        });
      }
    } catch (err) {
      console.error("fetchTodayActivity error:", err);
    }
  };

  const getCertificateNotApproved = () => {
    let query = {
      query: `SELECT count(*) as no_of_rows FROM certificatesView where status != -1 and calibratedby is NOT NULL and approvedby is NULL and discID IN (${disciplineID})`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, query)
      .then((res) => {
        let resCount = res.data[0].no_of_rows;
        setCertificateApprovedCount(resCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDatasheetCalibrated = () => {
    let query = {
      query: `select count(*) as no_of_rows from datasheets where assignedUser= ${userId} and calibratedby is null`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, query)
      .then((res) => {
        let resCount = res.data[0].no_of_rows;
        setDatashheetCalibratedPending(resCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    // Admin 
    if (userType == 1 || userType == 4) {
      fetchProjectsStats(projectsTimeframe);
    }

    if (userType == 1 || userType == 4) {
      getDisciplines();
      fetchPerformance(workReportTimeframe);
      fetchApproverPerformance(workReportTimeframe);
      fetchApprovalStats(approvalTimeFrame);
      fetchCalibrationTrend(calibrationTrendTimeframe);
      fetchCertStatusStats(certStatusTimeframe);
      fetchDiscWiseCalibration(discWiseTimeframe);
      fetchRecentInwards();
      fetchUpcomingDueDates();
      fetchTodayActivity();
    }

    if (moduleAccess.includes(5) && props.rolesInfo?.currentRole?.id == 2) {
      getCertificateNotApproved();
    }

    // Engineer
    if (userType == 2 && props.rolesInfo?.currentRole?.id == 1) {
      getDatasheetCalibrated();
    }
  }, [userType, props.rolesInfo?.currentRole?.id]);

  const getDisciplines = () => {
    let query = {
      query: "SELECT id, name FROM discipline WHERE status = 1",
    };
    axiosWithToken
      .post(BASE_URL + "dynamic", query)
      .then((res) => {
        setDisciplinesList(res.data);
        if (res.data.length > 0) {
          const firstDisc = res.data[0].id;
          setSelectedDiscipline(firstDisc);
          fetchDisciplineStats(firstDisc, disciplineTimeframe);
        }
      })
      .catch((err) => console.log("discipline fetching error: ", err));
  };

  const fetchDisciplineStats = (discId, timeframe = disciplineTimeframe) => {
    const condition = 
      timeframe === "today"
        ? ` AND DATE(lastModified) = CURDATE()`
        : timeframe === "monthly"
        ? ` AND MONTH(lastModified) = MONTH(CURDATE()) AND YEAR(lastModified) = YEAR(CURDATE())`
        : ``;

    const totalQuery = { query: `select count(*) as total from certificatesView where status != -1 and discID = ${discId}${condition}`};

    const calibratedQuery = { query: `select count(*) as calibrated from certificatesView where status != -1 and discID = ${discId} and approvedby is not null${condition}`}

    const pendingQuery = { query: `select count(*) as pending from certificatesView where status != -1 and discID = ${discId} and approvedby is null and rejectedBy is null${condition}`}

    const rejectedQuery = { query: `select count(*) as rejected from certificatesView where status != -1 and discID = ${discId} and rejectedBy is not null${condition}`}

    Promise.all([
      axiosWithToken.post(BASE_URL + "dynamic", totalQuery),
      axiosWithToken.post(BASE_URL + "dynamic", calibratedQuery),
      axiosWithToken.post(BASE_URL + "dynamic", pendingQuery),
      axiosWithToken.post(BASE_URL + "dynamic", rejectedQuery)
    ]).then(([totalRes, calibratedRes, pendingRes, rejectedRes]) => {
      const total = totalRes.data[0].total;
      const completed = calibratedRes.data[0].calibrated;
      const pending = pendingRes.data[0].pending;
      const rejected = rejectedRes.data[0].rejected;
      
      setDisciplineStats({ total, completed, pending, rejected });

      setPieData({
        labels: ["Completed Calibration", "Pending Calibration", "Rejected Calibration"],
        datasets: [
          {
            label: "Calibration Statistics",
            data: [completed, pending, rejected],
            backgroundColor: [
              "rgba(25, 118, 210, 1)",   
              "rgba(100, 181, 246, 1)",  
              "rgba(144, 164, 174, 1)"
            ],
            borderColor: [
              "rgba(25, 118, 210, 1)",   
              "rgba(100, 181, 246, 1)",   
              "rgba(144, 164, 174, 1)"   
            ],
            borderWidth: 1,
          },
        ],
      });
    }).catch(err => console.log("Stats fetching error: ", err));
  };

  const handleDisciplineChange = (event) => {
    const discId = Number(event.target.value);
    setSelectedDiscipline(discId);
    fetchDisciplineStats(discId, disciplineTimeframe);
  };


  // Fetch project stats for the 8 checkpoint track metrics with proper metric-specific date fields.
  const fetchProjectsStats = async (timeframe) => {
    const userFilter = isAdmin ? "" : ` AND createdby = ${userId}`;

    let srfWhere = "";
    let approvedCond = "approvedby IS NOT NULL";
    let calibCond = "totalReadings IS NOT NULL AND totalReadings > 0";
    let pendingCalibCond = "totalReadings IS NULL OR totalReadings = 0";
    let rejectedCond = "rejectedBy IS NOT NULL";
    let amendmentCond = "revisionNumber > 0";
    let pendingAppCond = "totalReadings IS NOT NULL AND totalReadings > 0 AND approvedby IS NULL AND rejectedBy IS NULL";
    let totalInstCond = "1=1";

    if (timeframe === "today") {
      srfWhere = "AND entryDate >= CURDATE() AND entryDate < DATE_ADD(CURDATE(), INTERVAL 1 DAY)";
      totalInstCond = "entryDate >= CURDATE() AND entryDate < DATE_ADD(CURDATE(), INTERVAL 1 DAY)";
      calibCond += " AND (calibrationDate >= CURDATE() OR entryDate >= CURDATE())";
      pendingCalibCond = `(${pendingCalibCond}) AND entryDate >= CURDATE()`;
      approvedCond += " AND approvedDate IS NOT NULL AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) = DATE(CONVERT_TZ(NOW(), '+00:00', '+05:30'))";
      rejectedCond += " AND (DATE(lastModified) = CURDATE() OR entryDate >= CURDATE())";
      amendmentCond += " AND (DATE(lastModified) = CURDATE() OR entryDate >= CURDATE())";
      pendingAppCond += " AND entryDate >= CURDATE()";
    } else if (timeframe === "monthly") {
      srfWhere = "AND entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND entryDate < DATE_ADD(DATE_FORMAT(CURDATE(), '%Y-%m-01'), INTERVAL 1 MONTH)";
      totalInstCond = "entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND entryDate < DATE_ADD(DATE_FORMAT(CURDATE(), '%Y-%m-01'), INTERVAL 1 MONTH)";
      calibCond += " AND (calibrationDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01') OR entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01'))";
      pendingCalibCond = `(${pendingCalibCond}) AND entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01')`;
      approvedCond += ` AND approvedDate IS NOT NULL 
        AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) >= DATE_FORMAT(CONVERT_TZ(NOW(), '+00:00', '+05:30'), '%Y-%m-01')
        AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) < DATE_ADD(DATE_FORMAT(CONVERT_TZ(NOW(), '+00:00', '+05:30'), '%Y-%m-01'), INTERVAL 1 MONTH)`;
      rejectedCond += " AND (lastModified >= DATE_FORMAT(CURDATE(), '%Y-%m-01') OR entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01'))";
      amendmentCond += " AND (lastModified >= DATE_FORMAT(CURDATE(), '%Y-%m-01') OR entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01'))";
      pendingAppCond += " AND entryDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01')";
    }

    try {
      const [inwardRes, instStatsRes] = await Promise.all([
        runDynamicQuery(`
          SELECT COUNT(*) AS cnt
          FROM srfs
          WHERE status = 1 ${srfWhere} ${userFilter}
        `),
        runDynamicQuery(`
          SELECT 
            SUM(CASE WHEN ${totalInstCond} THEN 1 ELSE 0 END) AS totalInstruments,
            SUM(CASE WHEN ${calibCond} THEN 1 ELSE 0 END) AS calibrated,
            SUM(CASE WHEN ${pendingCalibCond} THEN 1 ELSE 0 END) AS pendingCalibration,
            SUM(CASE WHEN ${approvedCond} THEN 1 ELSE 0 END) AS approvedCertificates,
            SUM(CASE WHEN ${rejectedCond} THEN 1 ELSE 0 END) AS rejectedCertificates,
            SUM(CASE WHEN ${amendmentCond} THEN 1 ELSE 0 END) AS amendmentCertificates,
            SUM(CASE WHEN ${pendingAppCond} THEN 1 ELSE 0 END) AS pendingApproved
          FROM certificatesView
          WHERE status != -1 ${userFilter}
        `),
      ]);

      const safeNum = (rows, key) => Number(rows?.[0]?.[key]) || 0;

      setProjectsStats({
        inward: safeNum(inwardRes, "cnt"),
        totalInstruments: safeNum(instStatsRes, "totalInstruments"),
        calibrated: safeNum(instStatsRes, "calibrated"),
        pendingCalibration: safeNum(instStatsRes, "pendingCalibration"),
        approvedCertificates: safeNum(instStatsRes, "approvedCertificates"),
        rejectedCertificates: safeNum(instStatsRes, "rejectedCertificates"),
        amendmentCertificates: safeNum(instStatsRes, "amendmentCertificates"),
        pendingApproved: safeNum(instStatsRes, "pendingApproved"),
      });

    } catch (err) {
      console.error("fetchProjectsStats error:", err);
    }
  };

  const fetchApproverPerformance = (timeframe) => {
    const currentUserName = localStorage.getItem("userName");
    
    const condition = timeframe === "today"
        ? "AND DATE(c.lastModified) = CURDATE()"
        : timeframe === "monthly"
        ? "AND MONTH(c.lastModified) = MONTH(CURDATE()) AND YEAR(c.lastModified) = YEAR(CURDATE())"
        : "";

    const query = {
      query: `SELECT 
                u.id,
                u.userName,
                COUNT(c.id) as approvalCount
              FROM users u
              INNER JOIN certificatesView c ON c.approvedby = u.id
              WHERE c.approvedby IS NOT NULL AND c.status != -1
              ${condition}
              AND (u.userName != 'bfi' OR '${currentUserName}' = 'bfi')
              GROUP BY u.id, u.userName
              ORDER BY approvalCount DESC;`
    };

    axiosWithToken.post(BASE_URL + "dynamic", query)
      .then((res) => {
        if (res.data.length > 0) {
          setApproverPerformanceData({
            topUser: { name: res.data[0].userName, count: res.data[0].approvalCount },
            minUser: { name: res.data[res.data.length - 1].userName, count: res.data[res.data.length - 1].approvalCount },
          });
        } else {
          setApproverPerformanceData({
            topUser: { name: "N/A", count: 0 },
            minUser: { name: "N/A", count: 0 },
          });
        }
      })
      .catch((err) => console.log("Approver Performance error: ", err));
  };

  const fetchPerformance = (timeframe) => {
    const currentUserName = localStorage.getItem("userName");

    const condition = timeframe === "today"
      ? "AND DATE(c.lastModified) = CURDATE()"
      : timeframe === "monthly"
      ? "AND MONTH(c.lastModified) = MONTH(CURDATE()) AND YEAR(c.lastModified) = YEAR(CURDATE())"
      : "";

    const query = {
      query: `SELECT 
                u.id,
                u.userName,
                COUNT(c.id) as calibrationCount
              FROM users u
              INNER JOIN certificatesView c ON c.calibratedby = u.id
              WHERE c.calibratedby IS NOT NULL
              ${condition}
              AND (u.userName != 'bfi' OR '${currentUserName}' = 'bfi')
              GROUP BY u.id, u.userName
              ORDER BY calibrationCount DESC;`
    };

    axiosWithToken.post(BASE_URL + "dynamic", query)
      .then((res) => {
        if (res.data.length > 0) {
          setPerformanceData({
            topUser: { name: res.data[0].userName, count: res.data[0].calibrationCount },
            minUser: { name: res.data[res.data.length - 1].userName, count: res.data[res.data.length - 1].calibrationCount },
          });
        } else {
          setPerformanceData({
            topUser: { name: "N/A", count: 0 },
            minUser: { name: "N/A", count: 0 },
          });
        }
      })
      .catch((err) => console.log("Performance fetching error: ", err));
  };

  const fetchApprovalStats = (timeframe) => {
    const condition = 
      timeframe === "today"
        ? `DATE(lastModified) = CURDATE()`
        : timeframe === "monthly"
        ? `MONTH(lastModified) = MONTH(CURDATE()) AND YEAR(lastModified) = YEAR(CURDATE())`
        : `1=1`;
        
    const approvalquery = {
  query: `SELECT 
            COUNT(*) as total,
            SUM(CASE WHEN approvedby IS NOT NULL THEN 1 ELSE 0 END) as approved,
            SUM(CASE WHEN approvedby IS NULL AND rejectedBy IS NULL THEN 1 ELSE 0 END) as pending
          FROM certificatesView 
          WHERE ${condition} AND status != -1`,
};

  axiosWithToken.post(BASE_URL + "dynamic", approvalquery).then((res) => {
    const {total, approved, pending} = res.data[0];
    setApprovalStats({ total, approved, pending });
    setApprovalPieData((prev) => ({
      ...prev,
      datasets:[
        {
          ...prev.datasets[0],
          data: [approved, pending],
        },
      ],
    }));
  }).catch((err) => console.log("Error in fetching Approval stats: ", err))
  };

  /////////////////////////////DashboardData////////////////////////

  const fetchCount = async (table, dateColumn, condition, extraWhere = "") => {
    try {
      const url = `${BASE_URL}dynamic`;
      let query;
      if (table == "standards") {
        query = `SELECT * FROM ${table} WHERE DATE(${dateColumn}) ${condition} AND status = 1 AND renewalStatus = 1`;
      }
      else if (table == "certificatesView") {
        query = `SELECT * FROM ${table} WHERE DATE(${dateColumn}) ${condition} ${extraWhere ? `AND ${extraWhere}` : ""}`;
      }
      else{
        query = `SELECT * FROM ${table} WHERE DATE(${dateColumn}) ${condition} AND status = 1 `;
      }
      if (userType == 3 && clientId) {
        if (table === "clients") {
          query += ` AND id = ${clientId}`;
        } else {
          query += ` AND clientId = ${clientId}`;
        }
      }
      const response = await axiosWithToken.post(url, { query });
      return response.data.length;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const fetchCountwihtoutDate = async (table, condition) => {
    try {
      const url = `${BASE_URL}dynamic`;
      let query;
        query = `SELECT * FROM ${table} WHERE ${condition}`;
      // if (userType == 3) {
      //   query += ` AND clientId = ${clientId}`;
      // }
      const response = await axiosWithToken.post(url, { query });
      return response.data.length;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

    const fetchUnionCount = async (condition) => {
        const query = `SELECT COUNT(*) as count FROM (SELECT id, nextDueDate, status, renewalStatus, clientId FROM certificatesView UNION ALL SELECT id, nextDueDate, status, renewalStatus, clientId FROM certificatesView_hist) AS combined WHERE ${condition} ${userType == 3 ? `AND clientId = ${clientId}` : ""}`;
        try {
            const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
            return res.data[0]?.count || 0;
        } catch (err) {
            console.error("fetchUnionCount error:", err);
            return 0;
        }
    };

  const fetchDataCounts = async () => {
    if (!userType) return;
    try {
      if (userType == 1 || userType == 4 || userType == 3) {
        // Admin & Client
        const multiMonthlyStatsQuery = {
          query: `
            SELECT 'clients' as category,
              COUNT(*) as total,
              SUM(CASE WHEN MONTH(lastModified) = MONTH(CURDATE()) AND YEAR(lastModified) = YEAR(CURDATE()) THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN MONTH(lastModified) = MONTH(DATE_SUB(CURDATE(), INTERVAL 1 MONTH)) AND YEAR(lastModified) = YEAR(DATE_SUB(CURDATE(), INTERVAL 1 MONTH)) THEN 1 ELSE 0 END) as last
            FROM clients WHERE status = 1 ${userType == 3 ? `AND id = ${clientId}` : ""}
            UNION ALL
            SELECT 'certs' as category,
              COUNT(*) as total,
              SUM(CASE WHEN approvedDate IS NOT NULL
                AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) >= DATE_FORMAT(CONVERT_TZ(NOW(), '+00:00', '+05:30'), '%Y-%m-01')
                AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) < DATE_ADD(DATE_FORMAT(CONVERT_TZ(NOW(), '+00:00', '+05:30'), '%Y-%m-01'), INTERVAL 1 MONTH)
                THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN approvedDate IS NOT NULL
                AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) >= DATE_FORMAT(DATE_SUB(CONVERT_TZ(NOW(), '+00:00', '+05:30'), INTERVAL 1 MONTH), '%Y-%m-01')
                AND DATE(CONVERT_TZ(approvedDate, '+00:00', '+05:30')) < DATE_FORMAT(CONVERT_TZ(NOW(), '+00:00', '+05:30'), '%Y-%m-01')
                THEN 1 ELSE 0 END) as last
            FROM certificatesView
            WHERE status != -1
              AND approvedby IS NOT NULL
              AND totalReadings IS NOT NULL
              AND totalReadings > 0
              ${userType == 3 ? `AND clientId = ${clientId}` : ""}
            UNION ALL
            SELECT 'duc' as category,
              SUM(CASE WHEN nextDueDate IS NOT NULL AND DATE(nextDueDate) <= CURDATE() THEN 1 ELSE 0 END) as total,
              SUM(CASE WHEN nextDueDate IS NOT NULL AND MONTH(nextDueDate) = MONTH(CURDATE()) AND YEAR(nextDueDate) = YEAR(CURDATE()) THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN nextDueDate IS NOT NULL AND MONTH(nextDueDate) = MONTH(DATE_SUB(CURDATE(), INTERVAL 1 MONTH)) AND YEAR(nextDueDate) = YEAR(DATE_SUB(CURDATE(), INTERVAL 1 MONTH)) THEN 1 ELSE 0 END) as last
            FROM (
                SELECT nextDueDate, status, renewalStatus, clientId FROM certificatesView 
                UNION ALL 
                SELECT nextDueDate, status, renewalStatus, clientId FROM certificatesView_hist
            ) AS combined
            WHERE status != -1 AND renewalStatus = 1 ${userType == 3 ? `AND clientId = ${clientId}` : ""}
            UNION ALL
            SELECT 'master' as category,
              SUM(CASE WHEN validUpto IS NOT NULL AND validUpto <= CURDATE() + INTERVAL 20 DAY THEN 1 ELSE 0 END) as total,
              SUM(CASE WHEN MONTH(validUpto) = MONTH(CURDATE()) AND YEAR(validUpto) = YEAR(CURDATE()) THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN MONTH(validUpto) = MONTH(DATE_SUB(CURDATE(), INTERVAL 1 MONTH)) AND YEAR(validUpto) = YEAR(DATE_SUB(CURDATE(), INTERVAL 1 MONTH)) THEN 1 ELSE 0 END) as last
            FROM standards WHERE status != -1 AND renewalStatus = 1 ${userType == 3 ? "AND 1=0" : ""}
          `
        };

        const resM = await axiosWithToken.post(BASE_URL + "dynamic", multiMonthlyStatsQuery);
        const statsMap = {};
        resM.data.forEach(row => {
          statsMap[row.category] = { current: row.curr || 0, last: row.last || 0, total: row.total || 0 };
        });
        setOverallMonthlyStats({
          clients: statsMap.clients || { current: 0, last: 0, total: 0 },
          certs: statsMap.certs || { current: 0, last: 0, total: 0 },
          renewals: statsMap.duc || { current: 0, last: 0, total: 0 },
          masters: statsMap.master || { current: 0, last: 0, total: 0 },
        });

        // Parallel api call for admin & Client
        const [
          todaysClientsCount,
          todaysSrfsCount,
          todaysCertificatesCount,
          todaysRenewalsCount,
          overAllActiveIncCount,
          overAllRenewalCount,
          todayClientDueCount,
          masterRenewalCount
        ] = await Promise.all([
          (userType == 1 || userType == 4) ? fetchCount("clients", "lastModified", "= CURDATE()") : Promise.resolve(0),
          (userType == 1 || userType == 4) ? fetchCount("srfs", "lastModified", "= CURDATE()") : Promise.resolve(0),
          fetchCount("certificatesView", "CONVERT_TZ(approvedDate, '+00:00', '+05:30')", "= DATE(CONVERT_TZ(NOW(), '+00:00', '+05:30'))", "approvedby IS NOT NULL AND totalReadings IS NOT NULL AND totalReadings > 0"),
          fetchUnionCount(`DATE(nextDueDate) = CURDATE() AND status != -1 AND renewalStatus = 1`),
          (userType == 1 || userType == 4) ? fetchCount("standards", "validUpto", "<= CURDATE() AND status != -1 AND renewalStatus = 1") : Promise.resolve(0),
          fetchUnionCount(`DATE(nextDueDate) <= CURDATE() AND status != -1 AND renewalStatus = 1`),
          fetchUnionCount(`DATE(nextDueDate) = CURDATE() AND status != -1 AND renewalStatus = 1`),
          (userType == 1 || userType == 4) ? fetchCount("standards", "validUpto", "<= CURDATE() + INTERVAL 20 DAY AND status != -1 AND renewalStatus = 1") : Promise.resolve(0)
        ]);

        setCounts(prev => ({
          ...prev,
          todaysClientsCount,
          todaysSrfsCount,
          todaysCertificatesCount,
          todaysRenewalsCount,
          overAllActiveIncCount,
          overAllRenewalCount,
          todayClientDueCount,
          masterRenewalCount
        }));
      }

      if (userType == 2) {
        // parallel api call Engineer
        const [
          selfJobs,
          assignedJobs,
          pendingJobs,
          completedJobs,
          engineerRenewals,
          masterRenewalCount
        ] = await Promise.all([
          fetchCountwihtoutDate("datasheets", `createdby = ${userId}`),
          fetchCountwihtoutDate("datasheets", `assignedUser = ${userId}`),
          fetchCountwihtoutDate("datasheets", `(totalReadings IS NULL OR totalReadings = 0) and (createdby = ${userId} or assignedUser = ${userId})`),
          fetchCountwihtoutDate("datasheets", `(totalReadings IS NOT NULL and totalReadings > 0) and (createdby = ${userId} or assignedUser = ${userId})`),
          fetchCountwihtoutDate("certificatesView", `renewalStatus = 1 and (nextDueDate IS NOT NULL and nextDueDate <= CURDATE()) and (createdby = ${userId} or assignedUser = ${userId})`),
          fetchCount("standards", "validUpto", "<= CURDATE() + INTERVAL 20 DAY")
        ]);

        const graphStatsQuery = {
          query: `SELECT 
                    SUM(CASE WHEN createdby = ${userId} AND (totalReadings IS NOT NULL AND totalReadings > 0) THEN 1 ELSE 0 END) as selfComp,
                    SUM(CASE WHEN createdby = ${userId} AND (totalReadings IS NULL OR totalReadings = 0) THEN 1 ELSE 0 END) as selfPend,
                    SUM(CASE WHEN assignedUser = ${userId} AND (totalReadings IS NOT NULL AND totalReadings > 0) THEN 1 ELSE 0 END) as assComp,
                    SUM(CASE WHEN assignedUser = ${userId} AND (totalReadings IS NULL OR totalReadings = 0) THEN 1 ELSE 0 END) as assPend
                  FROM datasheets WHERE (createdby = ${userId} OR assignedUser = ${userId})`
        };

        let selfCompleted = 0, selfPending = 0, assignedCompleted = 0, assignedPending = 0;
        try {
          const gRes = await axiosWithToken.post(BASE_URL + "dynamic", graphStatsQuery);
          if (gRes.data?.[0]) {
            selfCompleted = gRes.data[0].selfComp || 0;
            selfPending = gRes.data[0].selfPend || 0;
            assignedCompleted = gRes.data[0].assComp || 0;
            assignedPending = gRes.data[0].assPend || 0;
          }
        } catch (err) {
          console.error("Graph stats fetch error:", err);
        }

        setCounts(prev => ({
          ...prev,
          selfJobs,
          assignedJobs,
          pendingJobs,
          completedJobs,
          engineerRenewals,
          masterRenewalCount,
          selfCompleted,
          selfPending,
          assignedCompleted,
          assignedPending,
        }));
      }
    } catch (error) {
      console.error("fetchDataCounts error:", error);
    }

  };

  useEffect(() => {
    fetchDataCounts();
  }, [userType, userId, clientId]);

  // Engineer Bar Graph sync
  useEffect(() => {
    if (userType == 2 && counts) {
      setEngineerBarData(prev => ({
        ...prev,
        datasets: [
          {
            ...prev.datasets[0],
            data: [counts.assignedCompleted || 0, counts.selfCompleted || 0]
          },
          {
            ...prev.datasets[1],
            data: [counts.assignedPending || 0, counts.selfPending || 0]
          }
        ]
      }));
    }
  }, [counts, userType]);

  return (
    <EditWrap>
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >


        {(userType == 1 || userType == 4) ? (
          <>
            {/* Top Welcome Panoramic Banner */}
            <Box
              sx={{
                width: "100%",
                position: "relative",
                borderRadius: { xs: "12px", sm: "14px", md: "16px" },
                overflow: "hidden",
                backgroundImage: `linear-gradient(to right, rgba(15, 23, 42, 0.42) 0%, rgba(15, 23, 42, 0.1) 50%, rgba(15, 23, 42, 0.3) 100%), url(${WelcomeBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "center 30%",
                color: "#ffffff",
                p: { 
                  xs: "14px 18px", 
                  sm: "16px 22px", 
                  md: "18px 28px", 
                  lg: "20px 32px", 
                },
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                justifyContent: "space-between",
                gap: 2,
                boxShadow: "0 8px 24px -4px rgba(15, 23, 42, 0.16)",
                mt: 0.5,
                mb: 2,
                minHeight: { xs: "auto", md: "126px", lg: "132px" },
              }}
            >
              {/* Left Content */}
              <Box sx={{ maxWidth: { xs: "100%", md: "68%" }, zIndex: 1 }}>
                <Typography
                  sx={{
                    fontSize: { xs: "0.68rem", sm: "0.72rem", md: "0.74rem" },
                    fontWeight: 700,
                    textAlign: "left",
                    letterSpacing: "0.08em",
                    color: "rgba(255, 255, 255, 0.85)",
                    textTransform: "uppercase",
                    mb: 0.75,
                    fontFamily: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    textShadow: "0 1px 3px rgba(0, 0, 0, 0.35)",
                  }}
                >
                  WELCOME BACK, {(localStorage.getItem("userName") || "USER").toUpperCase()}
                </Typography>
                <Typography
                  component="h1"
                  sx={{
                    fontSize: { 
                      xs: "1.05rem", 
                      sm: "1.15rem", 
                      md: "1.25rem", 
                      lg: "1.36rem", 
                      xl: "1.52rem" 
                    },
                    fontWeight: 700,
                    color: "#ffffff",
                    lineHeight: 1.32,
                    letterSpacing: "-0.01em",
                    textAlign: "left",
                    mb: 0.9,
                    fontFamily: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    textShadow: "0 2px 8px rgba(0, 0, 0, 0.35)",
                  }}
                >
                  Empowering Laboratories
                  <br />
                  Through Digital Transformation
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  {["Accurate Results", "Complete Traceability", "Greater Compliance"].map((pill, idx) => (
                    <React.Fragment key={pill}>
                      {idx > 0 && (
                        <Box
                          component="span"
                          sx={{
                            width: "3px",
                            height: "3px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(255, 255, 255, 0.65)",
                            display: "inline-block",
                            mx: 0.3,
                          }}
                        />
                      )}
                      <Typography
                        component="span"
                        sx={{
                          fontSize: { xs: "0.72rem", sm: "0.76rem", md: "0.8rem" },
                          fontWeight: 500,
                          color: "rgba(255, 255, 255, 0.9)",
                          letterSpacing: "0.02em",
                          textShadow: "0 1px 3px rgba(0, 0, 0, 0.35)",
                        }}
                      >
                        {pill}
                      </Typography>
                    </React.Fragment>
                  ))}
                </Box>
              </Box>

              {/* Right Quote */}
              <Box
                sx={{
                  alignSelf: { xs: "flex-end", md: "center" },
                  textAlign: "right",
                  zIndex: 1,
                  pr: { xs: 0, md: 1 },
                  mt: { xs: 1, md: 0 },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "0.82rem", sm: "0.88rem", md: "0.95rem", lg: "1.02rem" },
                    fontStyle: "italic",
                    fontWeight: 500,
                    color: "rgba(255, 255, 255, 0.95)",
                    lineHeight: 1.38,
                    fontFamily: '"Georgia", serif, "Nunito"',
                    textShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
                    whiteSpace: "pre-line",
                  }}
                >
                  {`“Precision today\nfor a safer tomorrow.”`}
                </Typography>
                <Box
                  sx={{
                    width: { xs: "24px", md: "28px" },
                    height: "2px",
                    backgroundColor: "rgba(255, 255, 255, 0.65)",
                    ml: "auto",
                    mt: 0.8,
                    borderRadius: "2px",
                  }}
                />
              </Box>
            </Box>

            {/* Overall Statistics Container Card */}
            <DashboardWidgetCard
              sx={{
                mt: 1.5,
                mb: 2.5,
                height: 'auto !important',
                display: 'block',
                pt: { xs: 1.8, sm: '16px' },
                px: { xs: 1.8, sm: '20px' },
                pb: { xs: 1.8, sm: '16px' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#0f172a' }}>
                  Overall Statistics
                </Typography>
                {certificateApprovedCount != 0 && moduleAccess.includes(5) && props.rolesInfo?.currentRole?.id == 2 && (
                  <Link to="/certificate/count">
                    <button
                      type="button"
                      className="btn btn-warning btn-md"
                      style={{ borderRadius: '8px', fontWeight: 600, fontSize: '0.8rem', padding: '4px 12px' }}
                      onClick={() => sessionStorage.setItem("searched", "true")}
                    >
                      Approval Request ({certificateApprovedCount})
                    </button>
                  </Link>
                )}
              </Box>

              <Grid container spacing={2}>
                {(userType != 3
                  ? [
                        {
                          id: "dashboard_clients",
                          label: "Clients",
                          total: overallMonthlyStats.clients.total,
                          value: overallMonthlyStats.clients.current,
                          lastValue: overallMonthlyStats.clients.last,
                          valueLabel: "This Month",
                          icon: GroupIcon,
                          color: "#2563eb",
                          bg: "rgba(37, 99, 235, 0.08)",
                          link: "/master/client",
                        },
                        {
                          id: "dashboard_certificates",
                          label: "Certificates",
                          total: overallMonthlyStats.certs.total,
                          value: overallMonthlyStats.certs.current,
                          lastValue: overallMonthlyStats.certs.last,
                          valueLabel: "This Month",
                          icon: WorkspacePremiumIcon,
                          color: "#4f46e5",
                          bg: "rgba(79, 70, 229, 0.08)",
                          link: "/certificate",
                        },
                        {
                          id: "dashboard_renewal",
                          label: "DUC Renewals",
                          total: overallMonthlyStats.renewals.total,
                          value: overallMonthlyStats.renewals.current,
                          lastValue: overallMonthlyStats.renewals.last,
                          valueLabel: "This Month",
                          lastValueLabel: "Last Month",
                          icon: AutorenewIcon,
                          color: "#16a34a",
                          bg: "rgba(22, 163, 74, 0.08)",
                          link: "/scheduler",
                        },
                        {
                          id: "dashboard_Master_Renewals",
                          label: "Master Renewals",
                          total: overallMonthlyStats.masters.total,
                          value: overallMonthlyStats.masters.current,
                          lastValue: overallMonthlyStats.masters.last,
                          valueLabel: "This Month",
                          lastValueLabel: "Last Month",
                          icon: AutorenewIcon,
                          color: "#16a34a",
                          bg: "rgba(22, 163, 74, 0.08)",
                          link: "/master/masterEQP/count",
                        },
                      ]
                    : [
                        {
                          id: "dashboard_certificates",
                          label: "Approved Certificates",
                          total: overallMonthlyStats.certs.total,
                          value: overallMonthlyStats.certs.current,
                          lastValue: overallMonthlyStats.certs.last,
                          valueLabel: "This Month",
                          icon: WorkspacePremiumIcon,
                          color: "#283593",
                          bg: "rgba(40,53,147,0.08)",
                          link: "/certificate",
                        },
                        {
                          id: "dashboard_renewal",
                          label: "DUC Renewals",
                          total: overallMonthlyStats.renewals.total,
                          value: overallMonthlyStats.renewals.current,
                          lastValue: overallMonthlyStats.renewals.last,
                          valueLabel: "This Month",
                          lastValueLabel: "Last Month",
                          icon: AutorenewIcon,
                          color: "#2e7d32",
                          bg: "rgba(46,125,50,0.10)",
                          link: "/scheduler",
                        },
                        {
                          id: "dashboard_dues",
                          label: "Dues",
                          total: overallMonthlyStats.renewals.total,
                          value: overallMonthlyStats.renewals.current,
                          lastValue: overallMonthlyStats.renewals.last,
                          valueLabel: "This Month",
                          lastValueLabel: "Last Month",
                          icon: AutorenewIcon,
                          color: "#2e7d32",
                          bg: "rgba(46,125,50,0.10)",
                          link: "/scheduler",
                        },
                      ]
                ).map((metric) => (
                  <CustomCard key={metric.id} metric={metric} />
                ))}
              </Grid>
            </DashboardWidgetCard>

            {/* Row 1: Calibration Trend & Certificate Status */}
            <Grid container spacing={2} sx={{ mb: 2.5 }}>
              <Grid item xs={12} md={6}>
                <CalibrationTrendWidget
                  data={calibrationTrendData}
                  timeframe={calibrationTrendTimeframe}
                  onTimeframeChange={(val) => {
                    setCalibrationTrendTimeframe(val);
                    fetchCalibrationTrend(val);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CertificateStatusWidget
                  stats={certStatusStats}
                  timeframe={certStatusTimeframe}
                  onTimeframeChange={(val) => {
                    setCertStatusTimeframe(val);
                    fetchCertStatusStats(val);
                  }}
                />
              </Grid>
            </Grid>

            {/* Row 2: Discipline Wise Calibration & Today's Activity */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <DisciplineWiseWidget
                  disciplines={discWiseList}
                  timeframe={discWiseTimeframe}
                  onTimeframeChange={(val) => {
                    setDiscWiseTimeframe(val);
                    fetchDiscWiseCalibration(val);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TodayActivityWidget counts={todayActivityCounts} />
              </Grid>
            </Grid>

            {/* Work Report Container Card */}
            <DashboardWidgetCard
              sx={{
                mt: 1,
                mb: 2.5,
                height: 'auto !important',
                display: 'block',
                pt: { xs: 1.8, sm: '16px' },
                px: { xs: 1.8, sm: '20px' },
                pb: { xs: 1.8, sm: '16px' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#0f172a' }}>
                  Work Report
                </Typography>
                <Select
                  value={workReportTimeframe}
                  onChange={(e) => {
                    setWorkReportTimeframe(e.target.value);
                    fetchPerformance(e.target.value);
                    fetchApproverPerformance(e.target.value);
                  }}
                  size="small"
                  sx={{
                    minWidth: 110,
                    height: 30,
                    fontSize: '0.78rem',
                    bgcolor: '#f8fafc',
                    borderRadius: '8px',
                    borderColor: '#e2e8f0',
                    fontWeight: 600,
                    '& .MuiSelect-select': { py: '3px', px: '10px' },
                  }}
                > 
                  <MenuItem value="today" sx={{ fontSize: '0.78rem' }}>Today</MenuItem>
                  <MenuItem value="monthly" sx={{ fontSize: '0.78rem' }}>This Month</MenuItem>
                  <MenuItem value="overall" sx={{ fontSize: '0.78rem' }}>Overall</MenuItem>
                </Select>
              </Box>

              <Grid container spacing={2}>
                {[
                  {
                    id: "top_calibrator",
                    label: "Top Calibrator",
                    userName: performanceData.topUser.name,
                    value: performanceData.topUser.count,
                    color: "#16a34a",
                    bg: "rgba(22, 163, 74, 0.08)",
                    icon: EmojiEventsIcon,
                  },
                  {
                    id: "min_calibrator",
                    label: "Lowest Calibrator",
                    userName: performanceData.minUser.name,
                    value: performanceData.minUser.count,
                    color: "#ea580c",
                    bg: "rgba(234, 88, 12, 0.08)",
                    icon: GroupIcon,
                  },
                  {
                    id: "top_approver",
                    label: "Top Approver",
                    userName: approverPerformanceData.topUser.name,
                    value: approverPerformanceData.topUser.count,
                    color: "#2563eb",
                    bg: "rgba(37, 99, 235, 0.08)",
                    icon: WorkspacePremiumIcon,
                  },
                  {
                    id: "min_approver",
                    label: "Lowest Approver",
                    userName: approverPerformanceData.minUser.name,
                    value: approverPerformanceData.minUser.count,
                    color: "#9333ea",
                    bg: "rgba(147, 51, 234, 0.08)",
                    icon: GroupIcon,
                  },
                ].map((metric) => (
                  <CustomCard key={metric.id} metric={metric} />
                ))}
              </Grid>
            </DashboardWidgetCard>

            {/* Recent Inwards and Upcoming Due Dates */}
            <Grid container spacing={2} sx={{ mt: 1, mb: 4 }}>
              <Grid item xs={12} lg={6.5} md={12}>
                <RecentInwardsWidget inwards={recentInwardsList} />
              </Grid>
              <Grid item xs={12} lg={5.5} md={12}>
                <UpcomingDueDatesWidget dueDates={upcomingDueDatesList} />
              </Grid>
            </Grid> 

            {/* Recent Inwards and Upcoming Due Dates */}
            {/* <Grid container spacing={2} sx={{ mt: 3, mb: 4 }}>
              <Grid item xs={12} lg={6.5} md={12}>
                <RecentInwardsWidget inwards={recentInwardsList} />
              </Grid>
              <Grid item xs={12} lg={5.5} md={12}>
                <UpcomingDueDatesWidget dueDates={upcomingDueDatesList} />
              </Grid>
            </Grid> */}

          </>
          ) : userType == 2 ? (
            // Engineer Dashboard
            <>
              <div component={Paper} sx={{ mt: 1 }}>
                <SectionHeader 
                  title="Engineer Overview" 
                  mt={1} 
                  action={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      {/* Approval Request */}
                      {certificateApprovedCount != 0 && moduleAccess.includes(5) && props.rolesInfo?.currentRole?.id == 2 && (
                        <Link to="/certificate/count">
                          <button
                            type="button"
                            className="btn btn-warning btn-md"
                            style={{ borderRadius: '8px', fontWeight: 600, marginRight: '10px' }}
                            onClick={() => sessionStorage.setItem("searched", "true")}
                          >
                            Approval Request ({certificateApprovedCount})
                          </button>
                        </Link>
                      )}
                      {/* Job Request Button */}
                      {props.rolesInfo?.currentRole?.id == 1 && userType == 2 && (
                        <Link to="/datasheet/count">
                          <button
                            type="button"
                            className="btn btn-warning btn-md"
                            style={{ borderRadius: '8px', fontWeight: 600 }}
                            onClick={() => sessionStorage.setItem("searched", "true")}
                          >
                            Job Request ({datashheetCalibratedPending})
                          </button>
                        </Link>
                      )}
                    </Box>
                  }
                />
                <Grid container spacing={2}>
                  {[
                    {
                      label: "Self Jobs",
                      value: counts.selfJobs || 0,
                      icon: ArticleIcon,
                      color: "#283593",
                      bg: "rgba(40,53,147,0.08)",
                      link: "/datasheet?filter=self",
                    },
                    {
                      label: "Assigned Jobs",
                      value: counts.assignedJobs || 0,
                      icon: GroupIcon,
                      color: "#283593",
                      bg: "rgba(40,53,147,0.08)",
                      link: "/datasheet?filter=assigned",
                    },
                    {
                      label: "Pending Jobs",
                      value: counts.pendingJobs || 0,
                      icon: HelpIcon,
                      color: "#283593",
                      bg: "rgba(40,53,147,0.08)",
                      link: "/datasheet?filter=pending",
                    },
                    {
                      label: "Completed Jobs",
                      value: counts.completedJobs || 0,
                      icon: CardGiftcardOutlinedIcon,
                      color: "#283593",
                      bg: "rgba(40,53,147,0.08)",
                      link: "/datasheet?filter=completed",
                    },
                    {
                      label: "DUC Renewal",
                      value: counts.engineerRenewals || 0,
                      icon: RotateLeftOutlinedIcon,
                      color: "#2e7d32",
                      bg: "rgba(46,125,50,0.10)",
                      link: "/scheduler?filter=engineerRenewals",
                    },
                    {
                      label: "Master Renewals",
                      value: counts.masterRenewalCount || 0,
                      icon: RotateLeftOutlinedIcon,
                      color: "#2e7d32",
                      bg: "rgba(46,125,50,0.10)",
                      link: "/master/masterEQP/count",
                    },
                  ].map((metric, idx) => (
                    <CustomCard key={idx} metric={metric} />
                  ))}
                </Grid>
              </div>

            </>
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                style={{
                  height: "100%",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                src={Dashboard_background}
                alt="dashboard_background"
              />
            </div>
          )}
          {/* Jobs Summary */}
          {userType == 2 && (
            <>
              <SectionHeader
                title="Jobs Summary"
                mt={4} 
              />
              <SummarySection 
                chart={<BarGraph data={engineerBarData} />}
                summaryTitle="Job Overview"
                stats={[
                  { label: "Total Jobs", value: (counts.selfJobs || 0) + (counts.assignedJobs || 0), color: "#283593", bg: "rgba(40,53,147,0.08)" },
                  { label: "Self Jobs", value: counts.selfJobs || 0, color: "#1976d2", bg: "rgba(25,118,210,0.08)" },
                  { label: "Assigned Jobs", value: counts.assignedJobs || 0, color: "#64b5f6", bg: "rgba(100,181,246,0.15)" },
                  { label: "Completed Jobs", value: counts.completedJobs || 0, color: "#2e7d32", bg: "rgba(46,125,50,0.10)" },
                ]}
                footerNote="Current status of all jobs."
                footerIconColor="info.main"
                chartColSize={6}
                statsColSize={6}
                paperSx={{ p: 4, borderRadius: 2, boxShadow: 1, borderColor: "divider" }}
              />
            </>
          )}
      </div>
    </EditWrap>
  );
}